export default __webpack_public_path__ + "static/media/credits-photo.ce7d1d76.jpg";